import moment from 'moment';

// The date input hands back partial text while the user types; only a complete
// date is worth sending to the API as a work history cutoff
export const workHistoryCutoff = (startDate: string): string | undefined =>
    moment(startDate, 'YYYY-MM-DD', true).isValid() ? startDate : undefined;
